import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { IOwners } from '../../../interfaces/merchant';
import { DateComponent } from '../../../components/DateComponent';
import { getTableValue } from '../../../components/table/table-helper';

export enum OwnerTableAccessorKeys {
	percentage = 'percentOwnership',
	name = 'firstName',
	birthDay = 'dateOfBirth',
	country = 'country',
	phone = 'phone',
	email = 'email',
}

export const defaultOwnerColumnSizing: ColumnSizing = {
	[OwnerTableAccessorKeys.percentage]: 50,
	[OwnerTableAccessorKeys.name]: 100,
	[OwnerTableAccessorKeys.birthDay]: 75,
	[OwnerTableAccessorKeys.country]: 75,
	[OwnerTableAccessorKeys.phone]: 100,
	[OwnerTableAccessorKeys.email]: 100,
};

export const defaultOwnerColumns: MRT_ColumnDef<IOwners>[] = [
	{
		accessorKey: OwnerTableAccessorKeys.percentage,
		header: 'Percent ownership',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Percent ownership</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}%
			</TableCell>
		)
	},
	{
		accessorKey: OwnerTableAccessorKeys.name,
		header: 'Name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Name</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<span className="fw-bolder">
					{renderedCellValue} {row?.original?.lastName}
				</span>
			</TableCell>
		)
	},
	{
		accessorKey: OwnerTableAccessorKeys.birthDay,
		header: 'Birthday',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Birthday</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<DateComponent value={renderedCellValue} />
			</TableCell>
		)
	},
	{
		accessorKey: OwnerTableAccessorKeys.country,
		header: 'Country',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Country</span>,
		Cell: ({ table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{getTableValue(row?.original?.address?.country)}
			</TableCell>
		)
	},
	{
		accessorKey: OwnerTableAccessorKeys.phone,
		header: 'Phone',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Phone</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: OwnerTableAccessorKeys.email,
		header: 'Email',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Email</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<div className="fc-text-overflow">
					{renderedCellValue}
				</div>
			</TableCell>
		)
	},
];
